import React, { useState, useEffect } from "react";
import { BoxArrowInRight, FileEarmarkTextFill, Gear, PersonFill } from 'react-bootstrap-icons';
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Row from "react-bootstrap/Row";
import Swal from 'sweetalert2';
import { isMobile } from '../../util/GeneralUtil';
import { LoginService } from "../../services/LoginService";
import { useLocation } from "react-router-dom";
import { sendMessage, ownSubscribe } from '../../stomp/StompSocket';
import * as BullCache from "../../util/BullCache";
import "../custom.css";
import { AdminService } from "../../services/AdminService";

const apiUrl = process.env.REACT_APP_API_URL;

function MobileTopBar({ activeMenu }) {
  const [showModal, setShowModal] = useState(false);
  var user = BullCache.getFromCache("user");
  const location = useLocation();
  const [mcxMarginResponse, setMcxMarginResponse] = useState(null);
  const [nseMarginResponse, setNseMarginResponse] = useState(null);
  const [globalMarginResponse, setGlobalMarginResponse] = useState(null);
  

  useEffect(() => {
    const viewport = document.querySelector("meta[name=viewport]");
    
      if(isMobile && (location.pathname.includes("/usersummary") ||
      location.pathname.includes("/mastersummary") ||  location.pathname.includes("/netposition") )){
          viewport.setAttribute("content", "width=device-width, initial-scale=1, user-scalable=yes");
      } else{
        viewport.setAttribute("content", "width=device-width, initial-scale=1, user-scalable=no");
      }
    }, [location.pathname]);

  useEffect(() => {
    setNseMarginResponse(user.nseMarginResponse);
    setMcxMarginResponse(user.mcxMarginResponse);
    setGlobalMarginResponse(user.globalMarginResponse);

    const timeout =  setTimeout(() => {
      ownSubscribe('/topic/script/update/'+user.adminId, function (msg) {
          if(msg?.body && msg?.body === 'true'){
              AdminService.getAdminScripts({ adminId: user.adminId, loginId: user.adminId })
            .then((resp) => {
              if (resp.code === 1 && resp.data.allScripts) {
                BullCache.saveToCache("allScripts", resp.data.allScripts);
              }
            })
            .catch((error) => {
              console.error("Error fetching scripts:", error);
            });
          }
        });
    });

    sendMessage('/app/topic/ping/'+user.adminId, {});
    const intervalId =  setInterval(() => {
           sendMessage('/app/topic/ping/'+user.adminId, {});
    }, 15000);

     return () => {
        clearInterval(intervalId); 
        clearTimeout(timeout);
      };

  }, []);

  const handleOpenModal = (e) => {

     LoginService.getAccountUpdate({adminId: user.adminId}).then((res => {
          if (res.code === 1) {
            var accountDetail = res.data.accountDetail;
            if(accountDetail){
              setMcxMarginResponse(accountDetail.mcxMarginResponse);
              setNseMarginResponse(accountDetail.nseMarginResponse);
              setGlobalMarginResponse(accountDetail.globalMarginResponse);
            }
          }
        }));

    e.stopPropagation(); 
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);


  const popover = (
    <Popover className={isMobile ? 'w-75' : 'w-25'}>
      <Popover.Body
        className="white-background-blue-text "
        style={{ borderRadius: "10px" }}
      >
        <Row >

          <Col xl={2} xs={2}></Col>
          <Col xs={9} className="fss-1">
            {user.userName}
          </Col>
        </Row>

        <Row className="fss-1 ">
          <Col xl={2} xs={2}>
            <div className="rounded-letter">
              {user.firstName.charAt(0)}
            </div>
          </Col>
          <Col xs={9}>
            {user.firstName}
          </Col>
        </Row>

        <Row className="fss-1 boder-padding-bottom">
          <Col xl={2} xs={2}></Col>
          <Col xs={9}>
            {(user.adminType === 'SUPER_MASTER' ? "SUPER_ADMIN" : user.adminType)}
          </Col>
        </Row>

        {mcxMarginResponse ? <>
        <Row className="fss-1 mt-1">
          <Col xs={3}> MCX </Col>
          <Col xl={9} xs={9}> {mcxMarginResponse?.usedLot ?? 0} / {mcxMarginResponse?.lot ?? 0} </Col>
        </Row> 
        <Row className="fss-1 mt-1 boder-padding-bottom">
          <Col xs={3}> </Col>
          <Col xl={9} xs={9}> {mcxMarginResponse?.usedAmount ?? 0} / {mcxMarginResponse?.amount ?? 0} </Col>
        </Row>
        </>: ""
        }

        {nseMarginResponse ?
        <Row className="mt-2 fss-1 boder-padding-bottom">
        
          <Col xs={3}>NSE </Col>
          <Col xl={9} xs={9}> {nseMarginResponse?.usedAmount ?? 0} / {nseMarginResponse?.amount ?? 0} </Col>
        </Row>
        : ""
        }
         {globalMarginResponse ?
        <Row className="mt-2 fss-1 boder-padding-bottom">
        
          <Col xs={4}>GLOBAL </Col>
          <Col xl={8} xs={8}  className="ps-0"> {globalMarginResponse?.usedAmount ?? 0} / {globalMarginResponse?.amount ?? 0} </Col>
        </Row>
        : ""
        }

        <Row className="mt-2 fss-1 boder-padding-bottom">

          <Col xs={1}>
          <Gear></Gear>
          </Col>
          <Col xl={9} xs={10}>
            <a href="/changePassword" className="link-style">
              Change Password
            </a>
          </Col>

        </Row>

        <Row className="mt-1 fss-1 boder-padding-bottom">
          <Col xs={1}>
            <FileEarmarkTextFill></FileEarmarkTextFill>
          </Col>
          <Col xl={9} xs={10}>
            <a href="/rule" className="link-style">
              Rules & Regulation
            </a>
          </Col>
        </Row>

        <Row className="mt-1 fss-1 boder-padding-bottom" >
          <Col xs={1}>
            <BoxArrowInRight></BoxArrowInRight>
          </Col>

          <Col xl={9} xs={10}>
            <a href="/login" className="link-style">
              Log Out
            </a>
          </Col>
        </Row>
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      <Row className=" w-100 no-print">
        <Col xl={2} xs={3} className="p-1 d-sm-none d-md-block text-center">
          <img
            className="h-75 w-100 mt-1"
            src="img/logo.png"
          />
        </Col>
       
        <Col xl={6} xs={7} className=" mt-1 text-center fw-bold pt-2">
          {activeMenu}
        </Col>

        <Col md={2} xs={2} className="pb-1 ps-1 pe-0">
         <Row className="float-end">
              <Col xl={2} xs={1}>
                <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
                    <Button
                      variant="light"
                      className="mt-1 pb-2 blue-background-white-text"
                      onClick={handleOpenModal}
                    >
                      <PersonFill></PersonFill>
                    </Button>
                  </OverlayTrigger>
              </Col>
              {!isMobile ?
              <Col xl={9} xs={9} className="mt-1 pt-1 ms-3 fss-08">
               <div className="ms-2"> {user.firstName } 
               <br></br>
               {(user.adminType === 'SUPER_MASTER' ? "SUPER_ADMIN" : user.adminType) +" "+ user.userName}</div></Col>
               : null}
          </Row>
        </Col>
      </Row>
      
    </>
  );
}

export default MobileTopBar;
